module.exports = __webpack_public_path__ + "img/bow-tie.22abb3f6.png";